import { type Conversation, type Message } from "shared/apiClient";
import { ConversationPhase } from "shared/types";
import { AnalysisCalloutType } from "shared/components";

export type CalloutAction = {
  name: string;
  action_type: "open_tab" | "restart";
  url?: string;
};

export type RoutingQuestionData = {
  blocking?: boolean;
  analysis_callouts?: Array<{
    content: string;
    title: string;
    type: string;
    actions: Array<CalloutAction>;
    color: AnalysisCalloutType;
  }>;
};

export const RoutingRenderType = {
  DISCLAIMER: "DISCLAIMER",
  OFF_TOPIC: "OFF_TOPIC",
} as const;
export type RoutingRenderType =
  (typeof RoutingRenderType)[keyof typeof RoutingRenderType];

export type UseRoutingRenderTypeArgs = {
  conversation: Conversation | undefined | null;
  message: Message | undefined | null;
};

export function useRoutingRenderType({
  conversation,
  message,
}: UseRoutingRenderTypeArgs): RoutingRenderType {
  const questionData: RoutingQuestionData = message?.question_data || {};

  const offTopic = conversation?.phase === ConversationPhase.off_topic;

  if (offTopic) {
    return RoutingRenderType.OFF_TOPIC;
  }

  if (questionData.blocking) {
    return RoutingRenderType.OFF_TOPIC;
  }

  return RoutingRenderType.DISCLAIMER;
}
